import React from 'react';
import { Link } from 'react-router-dom';
import { Zap, Facebook, Instagram, MapPin, Phone, Mail } from 'lucide-react';
export function Footer() {
  return <footer className="bg-ink text-off-white pt-20 pb-24 md:pb-10" data-id="element-211">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-212">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16" data-id="element-213">
          {/* Brand & Contact */}
          <div className="flex flex-col gap-6" data-id="element-214">
            <Link to="/" className="flex items-center group" data-id="element-215">
              <img src="https://cdn.magicpatterns.com/uploads/6QQqEPrZA2yuM42sncUeU3/StormLogo.png" alt="Storm Taekwondo" className="block h-20 w-auto object-contain transition-transform group-hover:scale-105" data-id="element-216" />
            </Link>
            <p className="text-gray-warm font-medium" data-id="element-217">
              Building confidence, focus, and discipline in Farmington Hills
              through Olympic-style Taekwondo.
            </p>
            <div className="flex flex-col gap-3 mt-2" data-id="element-218">
              <a href="tel:517-220-0621" className="flex items-center gap-3 text-off-white hover:text-storm-red transition-colors" data-id="element-219">
                <Phone className="w-5 h-5 text-storm-red" data-id="element-220" />
                <span className="font-bold" data-id="element-221">517-220-0621</span>
              </a>
              <div className="flex items-start gap-3 text-off-white" data-id="element-222">
                <MapPin className="w-5 h-5 text-storm-red shrink-0 mt-1" data-id="element-223" />
                <span data-id="element-224">
                  24786 Crestview
                  <br data-id="element-225" />
                  Farmington Hills, MI 48335
                </span>
              </div>
            </div>
          </div>

          {/* Classes & Programs */}
          <div data-id="element-226">
            <h4 className="text-xl text-white mb-6" data-id="element-227">Classes & Programs</h4>
            <ul className="flex flex-col gap-3" data-id="element-228">
              <li data-id="element-229">
                <Link to="/karate-kids-classes.html" className="text-gray-warm hover:text-white transition-colors" data-id="element-230">
                  Kids Classes
                </Link>
              </li>
              <li data-id="element-231">
                <Link to="/kids-taekwondo-classes-in-farmington-hills-michigan" className="text-gray-warm hover:text-white transition-colors" data-id="element-232">
                  Kids Taekwondo (Ages 6+)
                </Link>
              </li>
              <li data-id="element-233">
                <Link to="/mini-troopers" className="text-gray-warm hover:text-white transition-colors" data-id="element-234">
                  Mini Troopers (Ages 3-5)
                </Link>
              </li>
              <li data-id="element-235">
                <Link to="/karate-adult-classes" className="text-gray-warm hover:text-white transition-colors" data-id="element-236">
                  Adult Taekwondo
                </Link>
              </li>
              <li data-id="element-237">
                <Link to="/FamilyKarateClasses.html" className="text-gray-warm hover:text-white transition-colors" data-id="element-238">
                  Family Classes
                </Link>
              </li>
              <li data-id="element-239">
                <Link to="/self-defense-classes-in-farmington-hills-michigan" className="text-gray-warm hover:text-white transition-colors" data-id="element-240">
                  Self-Defense
                </Link>
              </li>
              <li data-id="element-241">
                <Link to="/taekwondo-competitions-in-farmington-hills-michigan" className="text-gray-warm hover:text-white transition-colors" data-id="element-242">
                  Competition Team
                </Link>
              </li>
              <li data-id="element-243">
                <Link to="/summer-camp" className="text-storm-red font-bold hover:text-white transition-colors flex items-center gap-2" data-id="element-244">
                  <span className="w-1.5 h-1.5 rounded-full bg-storm-red animate-pulse" data-id="element-245" />
                  Summer Camp
                </Link>
              </li>
            </ul>
          </div>

          {/* Locations */}
          <div data-id="element-246">
            <h4 className="text-xl text-white mb-6" data-id="element-247">Service Areas</h4>
            <ul className="flex flex-col gap-3" data-id="element-248">
              <li data-id="element-249">
                <Link to="/farmington-hills-martial-arts-program-storm-taekwondo" className="text-gray-warm hover:text-white transition-colors" data-id="element-250">
                  Farmington Hills
                </Link>
              </li>
              <li data-id="element-251">
                <Link to="/novi-martial-arts-program-storm-taekwondo" className="text-gray-warm hover:text-white transition-colors" data-id="element-252">
                  Novi
                </Link>
              </li>
              <li data-id="element-253">
                <Link to="/commerce-martial-arts-program-storm-taekwondo" className="text-gray-warm hover:text-white transition-colors" data-id="element-254">
                  Commerce
                </Link>
              </li>
              <li data-id="element-255">
                <Link to="/livonia-martial-arts-program-storm-taekwondo" className="text-gray-warm hover:text-white transition-colors" data-id="element-256">
                  Livonia
                </Link>
              </li>
              <li data-id="element-257">
                <Link to="/farmington-martial-arts-program-storm-taekwondo" className="text-gray-warm hover:text-white transition-colors" data-id="element-258">
                  Farmington
                </Link>
              </li>
              <li data-id="element-259">
                <Link to="/waterford-martial-arts-program-storm-taekwondo" className="text-gray-warm hover:text-white transition-colors" data-id="element-260">
                  Waterford
                </Link>
              </li>
              <li data-id="element-261">
                <Link to="/northville-martial-arts-program-storm-taekwondo" className="text-gray-warm hover:text-white transition-colors" data-id="element-262">
                  Northville
                </Link>
              </li>
            </ul>
          </div>

          {/* CTA & Social */}
          <div className="flex flex-col gap-4" data-id="element-263">
            <h4 className="text-xl text-white mb-2" data-id="element-264">Ready to Start?</h4>
            <Link to="/SignMeUp" className="btn-primary text-center w-full" data-id="element-265">
              Check Availability
            </Link>

            <div className="pt-4 mt-2 border-t border-charcoal" data-id="element-266">
              <p className="text-xs uppercase tracking-wide text-gray-warm font-bold mb-3" data-id="element-267">
                Looking for a Summer Activity?
              </p>
              <Link to="/summer-camp" className="block bg-charcoal hover:bg-storm-red transition-colors text-white text-center font-display text-lg tracking-wide uppercase py-3 px-4 rounded-xl border border-storm-red/40" data-id="element-268">
                View Storm Summer Camp
              </Link>
            </div>

            <div className="flex items-center gap-4 mt-2" data-id="element-269">
              <a href="https://www.facebook.com/stormtkdunleashed" target="_blank" rel="noopener noreferrer" aria-label="Storm Taekwondo on Facebook" className="w-10 h-10 rounded-full bg-charcoal flex items-center justify-center hover:bg-storm-red transition-colors text-white" data-id="element-270">
                <Facebook className="w-5 h-5" data-id="element-271" />
              </a>
              <a href="https://www.instagram.com/stormtaekwondo" target="_blank" rel="noopener noreferrer" aria-label="Storm Taekwondo on Instagram" className="w-10 h-10 rounded-full bg-charcoal flex items-center justify-center hover:bg-storm-red transition-colors text-white" data-id="element-272">
                <Instagram className="w-5 h-5" data-id="element-273" />
              </a>
            </div>
          </div>
        </div>

        {/* More Storm Resources — added to reduce click depth to recently */}
        {/* modernized landing pages. Real crawlable anchors, no nofollow. */}
        <nav aria-label="More Storm resources" className="pt-8 border-t border-charcoal" data-id="element-274">
          <h4 className="text-xs uppercase tracking-wide text-gray-warm font-bold mb-4" data-id="element-275">
            More Storm Resources
          </h4>
          <ul className="flex flex-wrap gap-x-6 gap-y-3" data-id="element-276">
            <li data-id="element-277">
              <Link to="/do-some-martial-arts" className="text-off-white hover:text-storm-red transition-colors font-medium" data-id="element-278">
                Try Martial Arts
              </Link>
            </li>
            <li data-id="element-279">
              <Link to="/are-martial-arts-for-fitness" className="text-off-white hover:text-storm-red transition-colors font-medium" data-id="element-280">
                Martial Arts For Fitness
              </Link>
            </li>
            <li data-id="element-281">
              <Link to="/karate-kids-classes.html" className="text-off-white hover:text-storm-red transition-colors font-medium" data-id="element-282">
                Kids Classes
              </Link>
            </li>
            <li data-id="element-283">
              <Link to="/ContactUs.html" className="text-off-white hover:text-storm-red transition-colors font-medium" data-id="element-284">
                Contact Us
              </Link>
            </li>
          </ul>
        </nav>

        <div className="pt-8 mt-8 border-t border-charcoal flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-285">
          <p className="text-gray-warm text-sm" data-id="element-286">
            &copy; {new Date().getFullYear()} Storm Taekwondo. All rights
            reserved.
          </p>
          <p className="text-gray-warm text-sm" data-id="element-287">
            24786 Crestview, Farmington Hills, MI 48335
          </p>
        </div>
      </div>
    </footer>;
}